import React from 'react';
import { Button, Modal, Icon, Row, Col, Table, Spin, Tooltip } from 'antd';
import { injectIntl, FormattedMessage } from 'react-intl';
import { connect } from 'dva';
import { Link } from 'dva/router';
import Sticky from 'react-sticky-el';
import { AjaxTable, SearchComponent } from '../../../components';
import styles from './../styles.less';
import { PencilIcon, TrashIcon } from '../../Icons';

class CategoriesList extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      removedId: 0,
      filter: {
        search: '**',
      },
    };
  }

  componentDidMount() {
    this.props.dispatch({
      type: 'header/update',
      payload: {
        title: 'Component.Categories.List.Title',
        description: 'Component.Categories.List.Info',
      },
    });

    this.showNotifications();
  }

  getData(psf) {
    const filter = { name: this.state.filter.search, client_id: this.props.app.selectedClient.id };
    const params = psf.page ? psf : { sorting: psf.sorting, page: '1' };
    const payload = { filter, ...params };

    if (filter.name !== '**') {
      payload.filtered = true;
    }
    return this.props.dispatch({ type: 'categories/loadList', payload });
  }

  showNotifications() {
    this.props.dispatch({ type: 'app/showNotifications' });
  }

  showDeleteConfirm = (record) => {
    const self = this;
    Modal.confirm({
      title: this.props.intl.formatMessage({ id: 'Common.Attention' }),
      content: this.props.intl.formatMessage({ id: 'Component.Categories.Modal.Description' }, { categoryName: record.name }),
      okText: this.props.intl.formatMessage({ id: 'Common.Remove' }),
      cancelText: this.props.intl.formatMessage({ id: 'Common.Cancel' }),
      okType: 'danger',
      onOk() {
        self.remove(record.id);
      },
    });
  }

  remove(id) {
    this.props.dispatch({ type: 'categories/remove', payload: { id } }).then(() => {
      this.showNotifications();
      this.setState({ removedId: id });
    });
  }

  render() {
    const { Column } = Table;
    return (
      <div className={styles.containerLarge}>
        <Sticky
          className="sticky-bar"
          scrollElement=".ant-layout"
          stickyClassName="_sticky"
        >
          <div className="sticky-wrapper">
            <Row>
              <SearchComponent self={this} fieldPlaceholder={this.props.intl.formatMessage({ id: 'Component.Categories.List.SearchByName' })} />
              <Col span={14} className="text-right">
                <Button
                  size="large"
                  type="primary"
                  onClick={() => {
                    this.props.dispatch({
                      type: 'app/goToRoute',
                      payload: { routeName: 'CATEGORY_NEW' },
                    });
                  }}
                >
                  <Icon type="plus" />
                  <FormattedMessage id="Component.Categories.List.Action.Create" />
                </Button>
              </Col>
            </Row>
          </div>
        </Sticky>
        <Spin spinning={this.props.loading.models.categories}>
          <AjaxTable
            updateKey={JSON.stringify([this.state.filter, this.state.removedId])}
            getData={this.getData.bind(this)}
            rowKey="id"
            className={styles.categoryList}
          >
            <Column
              title={this.props.intl.formatMessage({ id: 'Grid.Column.Name' })}
              dataIndex="name"
              sorter
              className={styles.tableColumnWrap}
              render={data => (
                <div
                  data-label={this.props.intl.formatMessage({ id: 'Grid.Column.Name' })}
                >
                  {data}
                </div>
              )}
            />
            <Column
              title={this.props.intl.formatMessage({
                id: 'Grid.Column.Actions',
              })}
              key="actions"
              className="text-center"
              width={150}
              fixed="right"
              render={item => (
                <div className="actions" data-label={item.id}>
                  <Tooltip
                    className="hint action-wrap"
                    placement="top"
                    title={this.props.intl.formatMessage({
                      id: 'Grid.Column.Edit',
                    })}
                  >
                    <Link to={`./${item.id}/edit/`}>
                      <PencilIcon />
                    </Link>
                  </Tooltip>
                  <Tooltip
                    className="hint action-wrap"
                    placement="top"
                    title={this.props.intl.formatMessage({
                      id: 'Grid.Column.Delete',
                    })}
                  >
                    <button onClick={() => this.showDeleteConfirm(item)}>
                      <TrashIcon />
                    </button>
                  </Tooltip>
                </div>
              )}
            />
          </AjaxTable>
        </Spin>
      </div>
    );
  }
}

export default connect(
  ({ categories, loading, app }) => ({ categories, loading, app }),
)(injectIntl(CategoriesList));



// WEBPACK FOOTER //
// ./src/components/Categories/CategoriesList/CategoriesList.js